
# Technology

> techno = art, skill, craft
> logia = science, theory, study

Thus the definition is redundant and recursive.

Software/hardware lines are blurring into the next decade and the same with product and engineering roles.
